<template>
  <div class="propertycontrol">
    <div class="header">
      <div class="title">生活服务</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        社区有活动、公告通知，一键设置提醒，重要消息不再错过。
      </div>

      <div class="right">
        <div class="position">
          <img :src="ResidentControl2" alt="" />
          <img :src="ResidentControl3" alt="" />
          <img :src="ResidentControl4" alt="" />
        </div>
        <div class="logo">
          <img :src="ResidentControl1" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import ResidentControl1 from "../../../../assets/product/ResidentControl1.png";
import ResidentControl2 from "../../../../assets/product/ResidentControl2.png";
import ResidentControl3 from "../../../../assets/product/ResidentControl3.png";
import ResidentControl4 from "../../../../assets/product/ResidentControl4.png";

export default {
  setup() {
    return reactive({
      ResidentControl1: ResidentControl1,
      ResidentControl2: ResidentControl2,
      ResidentControl3: ResidentControl3,
      ResidentControl4: ResidentControl4,
    });
  },
};
</script>

<style scoped>
.propertycontrol {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .right {
  display: flex;
  position: relative;
}
.body .right .logo img {
  width: 332px;
  margin-left: 20px;
}
.body .right .position img {
  width: 236px;
  position: absolute;
}
.body .right .position img:nth-of-type(1) {
  right: 100%;
}
.body .right .position img:nth-of-type(2) {
  right: 125%;
  bottom: 0;
}
.body .right .position img:nth-of-type(3) {
  right: 150%;
  bottom: 0;
}
.body .left {
  width: 480px;
  font-size: 16px;
  color: #3d3d3d;
  line-height: 24px;
}
</style>
